import getProductLineLetter from '../../utils/api/getProductLineLetter';
import { apiModes } from '../../utils/constants';
import { useGetAccessoriesQuery } from '../apis/hondaRestApi';
import { useApiHost, useAppName, useLanguage, usePageState, useUserOrDefaultProvince, } from '../../utils/sitecoreContext';
export const useAccessoriesFetch = (transmissionId, vehicleType) => {
    const province = useUserOrDefaultProvince();
    const appName = useAppName();
    const hondaRestApiHost = useApiHost();
    const language = useLanguage();
    const pageState = usePageState();
    const productLineLetter = vehicleType
        ? getProductLineLetter.get(appName)[vehicleType]
        : getProductLineLetter.get(appName);
    const apiPath = `models/${productLineLetter}/${apiModes[pageState]}/transmissions/accessories/search`;
    const url = `https://${hondaRestApiHost}/${apiPath}`;
    return useGetAccessoriesQuery({
        url,
        params: {
            transmissionIds: transmissionId || '',
            province,
            acceptLanguage: language,
        },
    }, { skip: !transmissionId || !(transmissionId === null || transmissionId === void 0 ? void 0 : transmissionId.length) });
};
export default { useAccessoriesFetch };
